import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useDeletePlan() {
  const queryClient = useQueryClient();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function deletePlan(planID) {
    return privateFetch.delete(`/v1/admin/plan/${planID}`);
  }

  return useMutation(deletePlan, {
    onSuccess() {},
    onSettled() {
      queryClient.invalidateQueries('plan');
    },
  });
}

export default useDeletePlan;
